import { render, staticRenderFns } from "./order-editor.vue?vue&type=template&id=17a8963e&scoped=true&"
import script from "./order-editor.vue?vue&type=script&lang=js&"
export * from "./order-editor.vue?vue&type=script&lang=js&"
import style0 from "./order-editor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order-editor.vue?vue&type=style&index=1&id=17a8963e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8963e",
  null
  
)

export default component.exports